import { render, staticRenderFns } from "./PhysicalEventsDataEntryPage.vue?vue&type=template&id=edfca002&"
import script from "./PhysicalEventsDataEntryPage.vue?vue&type=script&lang=ts&"
export * from "./PhysicalEventsDataEntryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports